import React, { useEffect } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { auth, logInWithEmailAndPassword } from '../../api/firebase';
import SvgAnim from '../UI/SvgAnim';
import LoginForm from './form/LoginForm';

const admin = {
  name: 'Anurag',
  email: process.env.REACT_APP_ADMIN_EMAIL,
};

const Login = () => {
  const navigate = useNavigate();
  const [user, fetchingUser] = useAuthState(auth);

  const login = async (password) => {
    try {
      await logInWithEmailAndPassword(admin.email, password);
    } catch (e) {
      toast.error(e.message, {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
  };

  useEffect(() => {
    if (user) navigate('/');
  }, [navigate, user]);

  return (
    <section className="text-gray-600 body-font">
      <div className="container px-5 xl:px-52 py-24 mx-auto flex flex-wrap items-center h-screen">
        <SvgAnim />
        <LoginForm
          name={admin.name}
          login={login}
          isFetchingUser={fetchingUser}
        />
      </div>
    </section>
  );
};

export default Login;
